import PropTypes from 'prop-types';
import * as React from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { PreloaderInner } from './preloader-inner.component.js';
import { Preloader } from './preloader.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'large',
        'extra-large'
    ]), DEPRECATED_PROP_MESSAGES.size),
    size: PropTypes.oneOf([
        'standard',
        'large',
        'extra-large'
    ]),
    centered: PropTypes.bool,
    inline: PropTypes.bool,
    visuallyHiddenLabel: PropTypes.node,
    accessibleText: PropTypes.string
};
const BasicPreloader = renderWithRef('BasicPreloader', propTypes, (_param, ref)=>{
    var { visuallyHiddenLabel , accessibleText  } = _param, props = _object_without_properties(_param, [
        "visuallyHiddenLabel",
        "accessibleText"
    ]);
    const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenLabel;
    return /*#__PURE__*/ React.createElement(Preloader, _object_spread({
        ref: ref
    }, props), /*#__PURE__*/ React.createElement(PreloaderInner, null), accessibleNode !== null ? /*#__PURE__*/ React.createElement(VisuallyHidden, null, accessibleNode) : null, props.children);
});

export { BasicPreloader };
